import React from 'react'
import { COLORS } from 'static/constants'
import styled, { AnyStyledComponent } from 'styled-components'
interface IProps {
  label: string
  content: React.ReactNode
  description?: string
}

const DataRow: React.FC<IProps> = ({ label, content, description }) => {
  return (
    <DataRowWrapper>
      {description && <p className="description">{description}</p>}
      <div className="label">{label}</div>
      <div className="value">{content}</div>
    </DataRowWrapper>
  )
}

export default DataRow

const DataRowWrapper: AnyStyledComponent = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 24px;

  .description {
    margin: 0 0 4px 128px;
    font-size: 11px;
    color: ${COLORS.subText};
    width: calc(100% - 120px);
  }

  .label {
    width: 128px;
    flex: none;
    font-weight: bold;
    color: ${COLORS.subText};
  }

  .value {
    flex: 1;
    min-width: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;

    > a {
      color: ${COLORS.primary};
      text-decoration: underline;
    }
  }
`
